import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    root: {
        padding: '25px 125px',
        backgroundColor: '#D4D8E1',
    },    
    description: {
        width: '100%',
        fontWeight: 600,
        fontSize: '1.125rem',
        lineHeight: '27px',
        color: '#545454',
        textAlign: 'center',
        marginBottom: 20,
        [theme.breakpoints.down('xs')]: {
          fontSize: 18,
        },
      },
    lineaDegradadaBottom:{
        position: "relative",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 4,
        background: `linear-gradient(344deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)`,
    },
  }));
